// src/components/Header.js
import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Header = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [scrolled, setScrolled] = useState(false);
    const location = useLocation();

    useEffect(() => {
        const handleScroll = () => {
            setScrolled(window.scrollY > 50);
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    useEffect(() => {
        setIsMenuOpen(false);
    }, [location]);

    return (
        <>
            <header className={`header ${scrolled ? 'scrolled' : ''}`}>
                <div className="header-content">
                    <Link to="/" className="logo">
                        Udhaya Kumar A
                    </Link>
                    
                    <button 
                        className={`menu-toggle ${isMenuOpen ? 'active' : ''}`}
                        onClick={() => setIsMenuOpen(!isMenuOpen)}
                        aria-label="Toggle menu"
                    >
                        <span></span>
                        <span></span>
                        <span></span>
                    </button>

                    <nav className={`nav ${isMenuOpen ? 'nav-open' : ''}`}>
                        <Link 
                            to="/" 
                            className={`nav-link ${location.pathname === '/' ? 'active' : ''}`}
                            onClick={() => setIsMenuOpen(false)}
                        >
                            Home
                        </Link>
                        <Link 
                            to="/about" 
                            className={`nav-link ${location.pathname === '/about' ? 'active' : ''}`}
                            onClick={() => setIsMenuOpen(false)}
                        >
                            About
                        </Link>
                        <Link 
                            to="/ai-news" 
                            className={`nav-link ${location.pathname === '/ai-news' ? 'active' : ''}`}
                            onClick={() => setIsMenuOpen(false)}
                        >
                            AI News
                        </Link>
                        <Link 
                            to="/contact" 
                            className={`nav-link ${location.pathname === '/contact' ? 'active' : ''}`}
                            onClick={() => setIsMenuOpen(false)}
                        >
                            Contact
                        </Link>
                        <a 
                            href="/UdhayaKumar-Resume.pdf"
                            download="UdhayaKumar-Resume.pdf"
                            className="resume-btn"
                            onClick={() => setIsMenuOpen(false)}
                        >
                            Resume
                        </a>
                    </nav>
                </div>
            </header>

            {isMenuOpen && <div className="overlay" onClick={() => setIsMenuOpen(false)}></div>}

            <style jsx>{`
                .header {
                    position: fixed;
                    top: 0;
                    left: 0;
                    right: 0;
                    z-index: 1000;
                    background: transparent;
                    transition: all 0.3s ease;
                }

                .header.scrolled {
                    background: rgba(15, 15, 35, 0.95);
                    backdrop-filter: blur(10px);
                    border-bottom: 1px solid rgba(102, 126, 234, 0.2);
                }

                .header-content {
                    width: 100%;
                    padding: 1rem 2rem;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                }

                .logo {
                    font-size: 1.5rem;
                    font-weight: 700;
                    color: #667eea;
                    text-decoration: none;
                    font-family: 'Inter', sans-serif;
                    outline: none;
                }

                .logo:hover {
                    color: #764ba2;
                }

                .logo:focus {
                    outline: none;
                    box-shadow: none;
                }

                .nav {
                    display: flex;
                    align-items: center;
                    gap: 2rem;
                }

                .nav-link {
                    color: #a8b2d1;
                    text-decoration: none;
                    font-weight: 500;
                    transition: color 0.3s ease;
                    position: relative;
                    outline: none;
                }

                .nav-link:hover,
                .nav-link.active {
                    color: #667eea;
                }

                .nav-link:focus {
                    outline: none;
                    box-shadow: none;
                }

                .nav-link.active::after {
                    content: '';
                    position: absolute;
                    bottom: -4px;
                    left: 0;
                    right: 0;
                    height: 2px;
                    background: #667eea;
                }

                .resume-btn {
                    background: #667eea;
                    color: white;
                    padding: 0.5rem 1rem;
                    border-radius: 6px;
                    text-decoration: none;
                    font-weight: 500;
                    transition: background 0.3s ease;
                    outline: none;
                }

                .resume-btn:hover {
                    background: #764ba2;
                }

                .resume-btn:focus {
                    outline: none;
                    box-shadow: none;
                }

                .menu-toggle {
                    display: none;
                    background: none;
                    border: none;
                    width: 30px;
                    height: 24px;
                    position: relative;
                    cursor: pointer;
                    flex-direction: column;
                    justify-content: space-between;
                    outline: none;
                }

                .menu-toggle:focus {
                    outline: none;
                    box-shadow: none;
                }

                .menu-toggle span {
                    display: block;
                    height: 3px;
                    width: 100%;
                    background: #667eea;
                    border-radius: 2px;
                    transition: all 0.3s ease;
                }

                .menu-toggle.active span:nth-child(1) {
                    transform: rotate(45deg) translate(5px, 5px);
                }

                .menu-toggle.active span:nth-child(2) {
                    opacity: 0;
                }

                .menu-toggle.active span:nth-child(3) {
                    transform: rotate(-45deg) translate(7px, -6px);
                }

                .overlay {
                    display: none;
                }

                /* Mobile Styles */
                @media (max-width: 768px) {
                    .header-content {
                        padding: 1rem;
                    }

                    .menu-toggle {
                        display: flex;
                    }

                    .nav {
                        position: fixed;
                        top: 0;
                        right: -100%;
                        height: 100vh;
                        width: 250px;
                        background: rgba(15, 15, 35, 0.98);
                        backdrop-filter: blur(10px);
                        flex-direction: column;
                        justify-content: center;
                        gap: 2rem;
                        transition: right 0.3s ease;
                        border-left: 1px solid rgba(102, 126, 234, 0.2);
                    }

                    .nav.nav-open {
                        right: 0;
                    }

                    .nav-link {
                        font-size: 1.1rem;
                        padding: 0.5rem 0;
                    }

                    .resume-btn {
                        margin-top: 1rem;
                        padding: 0.75rem 1.5rem;
                    }

                    .overlay {
                        display: block;
                        position: fixed;
                        top: 0;
                        left: 0;
                        right: 0;
                        bottom: 0;
                        background: rgba(0, 0, 0, 0.5);
                        z-index: 999;
                    }
                }
            `}</style>
        </>
    );
};

export default Header;